import {
  ContextSelectionItem,
  ContextSelectionType,
} from './ContextSelectionContext';

export const hiddenChatRoutes = ['/chat', '/onboarding'] as const;
export type HiddenChatRoute = (typeof hiddenChatRoutes)[number];

export const isHiddenChatRoute = (
  pathname: string
): pathname is HiddenChatRoute =>
  (hiddenChatRoutes as readonly string[]).includes(pathname);

interface FilterContextSelectionItems {
  id: string;
  name: string;
}

export const filterContextSelectionItems = (
  contextSelection?: ContextSelectionItem[]
): FilterContextSelectionItems[] => {
  const selectedProducts =
    contextSelection?.flatMap((item) => {
      if (item.type === ContextSelectionType.Tool) {
        const selectedVersions = item.selectedVersions ?? [];
        if (selectedVersions.length > 0) {
          return selectedVersions.map((versionId) => ({
            id: versionId,
            name: item.title,
          }));
        }
      }

      return [
        {
          id: item.id,
          name: item.title,
        },
      ];
    }) ?? [];

  return selectedProducts;
};
